<template>
  <Layout :footer-style="2">
    <div class="aiPage">
      <div class="aiPage_content">
        <StaticBanner :banner-date="bannerDate" />
        <div class="content_body">
          <EcopAiBlock :item-list="itemList" title="核心价值" content="让企业经营管理更智能" />
          <div class="ai_product">
            <div class="container">
              <div class="ecop-ai-page_title" data-aos="fade-up">
                <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">产品界面</div>
                <p class="font-size-14 text-center tab-block_titles">让企业经营管理更智能</p>
              </div>
              <div class="ai_product_content" data-aos="zoom-in">
                <img src="@/assets/newImages/aiPage/产品界面_png@2x.png" alt="" />
              </div>
            </div>
          </div>
          <div class="deploymentMode position-relative">
            <div class="container">
              <div class="ecop-ai-page_title" data-aos="fade-up">
                <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">Deepseek+企业级元生AI平台，多样化的应用部署模式</div>
                <p class="font-size-14 text-center tab-block_titles">为大模型企业落地Plus服务，全方位助力企业实现大模型技术的深度应用。提供涵盖大模型咨询、模型共创、部署陪跑、内部培训以及联合实验
室建设等多元服务，为企业量身打造从技术选型到落地实施的一站式解决方案，加速企业智能化转型进程。</p>
              </div>
              <div class="deploymentMode_content position-relative" data-aos="zoom-in">
                <div class="deploymentMode_content_item position-relative" v-for="(item, index) in deploymentModeList" :key="index">
                  <div class="item_bg">
                  <div class="item_cont">
                    <div class="deploymentMode_content_item_title">
                      <div class="item_title_1">{{item.title}}</div>
                      <div class="item_title_2 line-height-3">{{item.content}}</div>
                    </div>
                    <div class="deploymentMode_content_item_list">
                      <div class="item_list_3">{{item.title2}}</div>
                      <div class="item_list_4 line-height-3" v-for="(tag, tagIndex) in item.tags" :key="tagIndex"><span><i class="bi bi-check-circle-fill mg-r-5"></i></span>{{tag}}</div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">

</style>
<script>
import Layout from "@/components/common/Layout";
import StaticBanner from "@/components/common/staticBanner/index.vue";
import EcopAiBlock from "@/components/common/ecopAiBlock/index.vue";

export default {
  name: "aiPage",
  components: { StaticBanner, Layout, EcopAiBlock },
  data() {
    return {
      menus: [],
      bannerDate: {
        url: require("@/assets/newImages/aiPage/元生平台_banner@2x.png"),
        title: '<span style="color:#152131">博信诚·</span><span style="color:#1B75ED">元生AI平台</span>',
        content: '<span style="color:#586E8A">让企业经营管理更智能</span>',
        contentWidth: '600px'
      },
      itemList: [
        {
          img: require("@/assets/newImages/aiPage/零代码开发@2x.png"),
          title: "零代码开发",
          content: "用户无需掌握复杂的编程语言和代码编写技能，只需通过自然语言描述需求，平台就自动将需求转化为可执行的应用程序。",
        },
        {
          img: require("@/assets/newImages/aiPage/多智能体协作@2x.png"),
          title: "多智能体协作",
          content: "平台内置多个智能体，每个智能体都有其特定的职责和功能",
        },
        {
          img: require("@/assets/newImages/aiPage/多工具调用@2x.png"),
          title: "多工具调用",
          content: "集成了多种实用工具，如数据库工具、API接口工具、数据分析工具等。",
        },
        {
          img: require("@/assets/newImages/aiPage/快速生成应用@2x.png"),
          title: "快速生成应用",
          content: "从用户提出需求到生成可运行的应用，整个过程非常快速，最快仅需3分钟就能开发出一个应用。",
        }
      ],
      deploymentModeList:[
        {
          title: "本地私有化部署",
          content:'安全部署Deepseek',
          title2:"一体机私有化部署",
          tags: ["开箱即用", "软硬集成", "本地安全"]
        },
        {
          title: "公用云部署",
          content:'应用实践Deepseek',
          title2:"定制组件+应用广场企业级AIAgent",
          tags: ["基于容器化部署", "高度加密", "严格访问控制"]
        },
        {
          title: "混合云部署",
          content:'行业定制',
          title2:"大模型公有云+元生AI平台本地部署",
          tags: ["模型微调", "垂直应用", "更懂行"]
        }
      ],
      windowWidth: document.documentElement.clientWidth,
    };
  },
  mounted() {
    
  },
  methods: {},
};
</script>
